<template>
  <div class="body">
    <div class="title">
      查看详情
      <!-- 面包屑导航区域 -->
      <div class="fansk">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/shouye' }"><span class="dsadf">
            首页
          </span></el-breadcrumb-item>
          <el-breadcrumb-item>信息管理</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/shenfenzhengshenhe' }">身份证审核</el-breadcrumb-item>
          <el-breadcrumb-item>查看详情</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <el-card class="padding">
      <el-col :span="12">
        <div class="fromdsadas">
          <div class="tiile">
            基本信息
          </div>
          <div>
            <el-form class="demo-form-inline" :label-position="labelPosition" @submit.native.prevent>
              <el-form-item label="头像" label-width="116px">
                <div class="flexsaa">
                  <img :src="Query.facepic" alt="" class="imgs" :onerror="defaultImg">
                </div>
              </el-form-item>
              <el-form-item label="姓名 " label-width="116px">
                {{Query.realname}}
              </el-form-item>
              <el-form-item label="昵称 " label-width="116px">
                {{Query.nickname}}
              </el-form-item>
              <el-form-item label="身份证号" label-width="116px">
                {{Query.idcard}}
              </el-form-item>
              <el-form-item label="手机号码" label-width="116px">
                {{Query.mobile}}
              </el-form-item>
              <el-form-item label="注册时间" label-width="116px" >
                {{Query.create_time}}
              </el-form-item>
              <el-form-item label="办公地址 " label-width="116px">
                {{Query.com_provincename}} {{Query.com_cityname}} {{Query.com_areaname}}{{Query.com_address}}
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="fromdsadas">
          <div class="tiile">
            认证信息
          </div>
          <div>
            <el-form class="demo-form-inline" :label-position="labelPosition">
              <el-form-item label="姓名" label-width="116px" >
                {{Query.realname}}
              </el-form-item>
              <el-form-item label="身份证号" label-width="116px" >
                {{Query.idcard}}
              </el-form-item>
              <el-form-item label="身份证文件" label-width="116px">
                  <el-button @click="openhuiyuan">查看</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="fromdsadas">
          <div class="tiile">
            状态信息
          </div>
          <div>
            <el-form class="demo-form-inline" :label-position="labelPosition">
              <el-form-item label="注册时间 " label-width="116px" >
                {{Query.create_time}}
              </el-form-item>
              <el-form-item label="审核状态" label-width="116px" >
                <span :style="{'color': (Query.verify_status === 0 ? '#F7D05C':Query.verify_status === 1 ? '#17ab3f':'#d54141')}">
                  {{Query.verify_status === 0?'未审核':Query.verify_status === 1?'已审核':'拒绝'}}
                </span>
              </el-form-item>
              <el-form-item label="审核时间" label-width="116px">
                {{Query.status_time}}
              </el-form-item>
            </el-form>
          </div>
        </div>
      </el-col>
    </el-card>
    <vxe-modal width="1004" ref="huiyuan" height="550" size="small" :show-footer="false" title="查看身份证文件" :show-close="true">
      <div class="czczczc">
        <div class="ssheader">
          <div class="flexwuwukai">
            <div class="tt">
              姓名
            </div>
            <div class="content">
              {{Query.realname}}
            </div>
          </div>
          <div class="flexwuwukai">
            <div class="tt">
              身份证号
            </div>
            <div class="content">
              {{Query.idcard}}
            </div>
          </div>
        </div>
        <div class="ssfoot">
          <div class="footbox mr  ">
            <el-image
              class="imgss"
              :src="Query.idcard_positive"
              :preview-src-list="srcList">
            </el-image>
            <div class="foottt">身份证国徽面</div>
          </div>
          <div class="footbox">
            <el-image
              class="imgss"
              :src="Query.idcard_back"
              :preview-src-list="srcList">
            </el-image>
            <div class="foottt">身份证人像面</div>
          </div>
        </div>
      </div>
    </vxe-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { userView } from '@/api/xinxi'

export default {
  name: 'index',
  computed: {
    ...mapState(['shenfenID']),
    defaultImg () {
      return 'this.src="' + require('../../assets/img/no.jpg') + '";'
    }
  },
  data () {
    return {
      labelPosition: 'left',
      Query: {},
      srcList: []
    }
  },
  created () {
    this.xiangqing()
  },
  methods: {

    openhuiyuan () {
      this.$refs.huiyuan.open()
    },
    xiangqing () {
      const obj = {
        token: sessionStorage.getItem('token'),
        id: this.shenfenID
      }
      userView(obj).then(({ data: res }) => {
        console.log('res', res)
        this.Query = res
        this.srcList.push(this.Query.idcard_positive)
        this.srcList.push(this.Query.idcard_back)
      })
    }
  }
}
</script>

<style scoped lang="less">
.czczczc{
  display:flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .ssheader{
    margin-top: 40px;
    width: 868px;
    height: 88px;
    opacity: 1;
    background: #f6f7fc;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    .flexwuwukai{
      flex: 0.5;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .tt{
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        text-align: left;
        color: #6c6c6c;
        margin-bottom: 11px;
      }
      .content{
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Heavy;
        font-weight: 800;
        text-align: left;
        color: #2e2e2e;
      }
    }
  }
  .mr{
    margin-right: 24px;
  }
  .ssfoot{
    margin-top: 20px;
    width: 868px;
    height: 313px;
    opacity: 1;
    //background: #f6f7fc;
    border-radius: 5px;
    display: flex;
    flex-direction: row;
    .footbox{
      width: 422px;
      height: 313px;
      opacity: 1;
      background: #f6f7fc;
      border-radius: 5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .imgss{
        width: 372px;
        height: 231px;
        opacity: 1;
        background: rgba(0,0,0,0.00);
      }
      .foottt{
        margin-top: 22px;
        font-size: 16px;
        font-family: PingFang SC, PingFang SC-Heavy;
        font-weight: 800;
        text-align: left;
        color: #2e2e2e;
      }
    }
  }
}
.fromdsadas{
  display:flex;
  flex-direction: column;
  .tiile{
    font-size: 16px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 42px;
  }
}
.imgbox{
  width: 500px;
  display:flex;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  .ssimg{
    width: 90px;
    height: 90px;
    opacity: 1;
    background: rgba(0,0,0,0.00);
    border-radius: 50%;
    margin-right: 12px;
    .scsa{
      width: 100%;
      height: 100%;
    }
  }
}
.huiyuan{
  display: flex;
  flex-direction: column;
  //align-items: center;
  text-align: left;
}
.imgs{
  width: 90px;
  height: 90px;
  opacity: 1;
  background: rgba(0,0,0,0.00);
  border-radius: 50%;
  margin-right: 12px;
}
.padding{
  padding:40px 50px
}
.flexsaa{
  display: flex;
  flex-direction: row;
  align-items: center;
  .huiyuanziliao{
    margin-left: 13px;
    width: 78px;
    height: 37px;
    opacity: 1;
    border: 1px solid rgba(61,154,255,0.50);
    background: white;
    border-radius: 2px;
    opacity: 1;
    font-size: 12px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: center;
    color: #3d9aff;
    letter-spacing: 0px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.body {
  display: flex;
  flex-direction: column;

  .title {
    opacity: 1;
    font-size: 30px;
    font-family: PingFang SC, PingFang SC-Heavy;
    font-weight: 800;
    text-align: left;
    color: #2e2e2e;
    letter-spacing: 0px;
    margin-bottom: 35px;
    display: flex;
    flex-direction: row;
    align-items: center;

    .fansk {
      margin-top: 30px;
      margin-left: 32px;
    }

    .dsadf {
      color: #3D9AFF;
    }
  }
}
</style>
